import { IconsList } from 'assets/icons';
import { useState } from 'react';

function IconViewwer({
  Icon,
  editColor = false,
}: {
  Icon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;

  editColor?: boolean;
}) {
  const [textColor, setTextColor] = useState('text-gray-dark');
  const [bgColor, setBgColor] = useState('bg-gray-150');
  return (
    <div
      className={`shadow rounded-lg py-4 flex items-center justify-center bg-gray-150`}
    >
      {editColor && (
        <div className="flex-1 flex flex-col h-full justify-between items-start">
          <button
            className="cursor-pointer py-2 px-4"
            onClick={() => setTextColor('text-gray-dark')}
          >
            <div className="bg-gray-dark h-2 w-2 rounded-full"></div>
          </button>
          <button
            className="cursor-pointer py-2 px-4"
            onClick={() => setTextColor('text-green')}
          >
            <div className="bg-green h-2 w-2 rounded-full"></div>
          </button>
          <button
            className="cursor-pointer py-2 px-4"
            onClick={() => setTextColor('text-red-dark')}
          >
            <div className="bg-red-dark h-2 w-2 rounded-full"></div>
          </button>

          <button
            className="cursor-pointer py-2 px-4"
            onClick={() => setTextColor('text-white')}
          >
            <div className="bg-white h-2 w-2 rounded-full"></div>
          </button>
        </div>
      )}

      <Icon className={`w-16 h-16 rounded ${textColor} ${bgColor}`} />

      {editColor && (
        <div className="flex-1 flex flex-col">
          <button
            className="cursor-pointer py-2 px-4 "
            onClick={() => setBgColor('bg-gray-150')}
          >
            <div className="bg-gray-150 border rounded h-2"></div>
          </button>
          <button
            className="cursor-pointer py-2 px-4"
            onClick={() => setBgColor('bg-green')}
          >
            <div className="bg-green rounded h-2"></div>
          </button>
        </div>
      )}
    </div>
  );
}
export default function ViewIcons() {
  const icons = IconsList;
  const [editColor, setEditColor] = useState(false);
  return (
    <>
      <div className="flex items-center mt-4">
        <label className="text-sm text-gray-dark mx-4 cursor-pointer">
          <span className="mr-4">Edit colors</span>
          <input
            className="cursor-pointer"
            type="checkbox"
            onChange={() => setEditColor((s) => !s)}
          />
        </label>
        <div>
          <span className="ml-4 text-gray-dark font-semibold">
            {icons.length}
          </span>
          <span className="ml-1 text-xs text-gray-light">icons</span>
        </div>
      </div>
      <div className="grid grid-cols-6 p-4 bg-gray-400 m-6 rounded-xl shadow gap-6 justify-between">
        {icons.map(({ Component, name }) => (
          <div key={name} className="">
            <div className="text-gray-700 text-xs mb-1">{name}</div>

            <IconViewwer Icon={Component} editColor={editColor} />
          </div>
        ))}
      </div>
    </>
  );
}
